// Meat footer: the shared footer (which owns all runtime brand / outlet
// contact data), dressed in the light cream meat skin via `mx-footer`.
import FooterCommon from './FooterCommon.jsx';

export default function FooterMeat() {
  return (
    <div className="mx-footer">
      <FooterCommon />
    </div>
  );
}
